import React from "react";
import { cn } from "@/lib/utils";
import { initials, avatarColor } from "@/lib/format";

const intentStyles = {
  LOW: "bg-slate-100 text-slate-700 border-slate-200",
  MEDIUM: "bg-blue-50 text-blue-700 border-blue-200",
  HIGH: "bg-emerald-50 text-emerald-700 border-emerald-200",
  URGENT: "bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200",
};
export const IntentBadge = ({ value }) => (
  <span className={cn("inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold", intentStyles[value] || intentStyles.LOW)}>
    {value || "LOW"}
  </span>
);

const riskStyles = {
  LOW: "bg-emerald-50 text-emerald-700 border-emerald-200",
  MEDIUM: "bg-amber-50 text-amber-800 border-amber-200",
  HIGH: "bg-red-50 text-red-700 border-red-200",
};
export const RiskBadge = ({ value }) => (
  <span className={cn("inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold", riskStyles[value] || riskStyles.LOW)}>
    {value || "LOW"} RISK
  </span>
);

const statusStyles = {
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  paused: "bg-slate-100 text-slate-600 border-slate-200",
  draft: "bg-slate-100 text-slate-600 border-slate-200",
  scheduled: "bg-blue-50 text-blue-700 border-blue-200",
  completed: "bg-violet-50 text-violet-700 border-violet-200",
  open: "bg-blue-50 text-blue-700 border-blue-200",
};
export const StatusBadge = ({ value }) => (
  <span className={cn("inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold capitalize", statusStyles[value] || statusStyles.draft)}>
    {value}
  </span>
);

export const ScorePill = ({ score }) => {
  const s = Number(score) || 0;
  const color = s >= 80 ? "text-emerald-700 bg-emerald-50 border-emerald-200" : s >= 50 ? "text-blue-700 bg-blue-50 border-blue-200" : "text-slate-600 bg-slate-100 border-slate-200";
  return <span className={cn("inline-flex items-center rounded-md border px-1.5 py-0.5 text-xs font-bold tabular-nums", color)}>{s}</span>;
};

export const Avatar = ({ name = "", src, size = 32 }) => {
  const [err, setErr] = React.useState(false);
  if (src && !err) {
    return <img src={src} alt={name} onError={() => setErr(true)} className="rounded-full object-cover ring-2 ring-white shadow-sm" style={{ width: size, height: size }} />;
  }
  return (
    <div className="rounded-full flex items-center justify-center text-white font-semibold ring-2 ring-white shadow-sm" style={{ width: size, height: size, background: avatarColor(name), fontSize: size * 0.38 }}>
      {initials(name)}
    </div>
  );
};
